import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root",
})
export class FilesPermissionGroupService {
  public url: string;
  public identity;
  public token;
  public headers: HttpHeaders;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem("token"));
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  private postRequest(
    endpoint: string,
    params: string,
    headers: HttpHeaders
  ): Observable<any> {
    return this._http
      .post(this.url + endpoint, params, { headers })
      .pipe(map((res) => res as any));
  }

  getTaggingGroups(token: string): Observable<any> {
    const params = "authorization=" + token;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.postRequest(
      "/filepermissionsgroup/list?page=1",
      params,
      headers
    );
  }
  getGroups(token: string, company_id): Observable<any> {
    const params = "authorization=" + token;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.postRequest(
      "/filepermissionsgroup/listbycompany/" + company_id,
      params,
      headers
    );
  }

  newTagGroup(token: string, group: any): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(group));
    const params = "json=" + json + "&authorization=" + token;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.postRequest(
      "/filepermissionsgroup/new?page=1",
      params,
      headers
    );
  }

  editTagGroup(token: string, id: string, group: any): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(group));
    const params = "json=" + json + "&authorization=" + token;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.postRequest(
      "/filepermissionsgroup/edit/" + id + "?page=1",
      params,
      headers
    );
  }

  delete(token: string, id: string): Observable<any> {
    const params = "authorization=" + token;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.postRequest(
      "/filepermissionsgroup/remove/" + id + "?page=1",
      params,
      headers
    );
  }

  detailTagGroups(token: string, id: string): Observable<any> {
    const params = "authorization=" + token;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.postRequest(
      "/filepermissionsgroup/detail/" + id + "?page=1",
      params,
      headers
    );
  }

  listByUser(
    token: string,
    id: string,
    page = 1,
    perPage = 10,
    filtros: any[] = []
  ): Observable<any> {
    let url;
    url = `${this.url}/filepermissionsgroup/listbyuser/${id}`;

    url = url + "page=" + page + "&perpage=" + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }

    return this.petition(url);
  }
  petition(url, json = null, type = null) {
    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this._http.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => {
        /*if (res.code === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }*/
        return res;
      })
    );
  }
}
